import { KeyValue } from '@/main/models/common';
import { PartBrandDomainRequest } from '@/main/models/request';

export enum BrandTypes {
  GET_BRAND = '@brand/GET_BRAND',
  SAVE_BRAND = '@brand/SAVE_BRAND',
  RESET_REDUCER_BRAND = '@brand/RESET_REDUCER_BRAND'
}

export interface BrandState {
  readonly brand: {
    data: KeyValue[] | null;
    errorMessages: string[] | null;
    isError: boolean;
    isLoading: boolean;
  };
}

export interface GetBrand {
  type: typeof BrandTypes.GET_BRAND;
  payload: {
    request: PartBrandDomainRequest | null;
  };
}

export interface SaveBrand {
  type: typeof BrandTypes.SAVE_BRAND;
  payload: {
    data: KeyValue[] | null;
    isError: boolean;
    errorMessages: string[] | null;
  };
}

export interface ResetReducerBrand {
  type: typeof BrandTypes.RESET_REDUCER_BRAND;
}

export type BrandActionTypes = GetBrand | SaveBrand | ResetReducerBrand;

